import React from 'react';

function Publications({ language, t }) {
  const isArabic = language === 'ar';

  const articles = [
    {
      title: t.article1,
      date: t.article1Date,
      excerpt: t.article1Excerpt,
      category: t.consumerLaw
    },
    {
      title: t.article2,
      date: t.article2Date,
      excerpt: t.article2Excerpt,
      category: t.consumerLaw
    },
    {
      title: t.article3,
      date: t.article3Date,
      excerpt: t.article3Excerpt,
      category: t.rentalLaw
    },
    {
      title: t.article4,
      date: t.article4Date,
      excerpt: t.article4Excerpt,
      category: t.familyLaw
    },
    {
      title: t.article5,
      date: t.article5Date,
      excerpt: t.article5Excerpt,
      category: t.commercialLaw
    },
    {
      title: t.article6,
      date: t.article6Date,
      excerpt: t.article6Excerpt,
      category: t.inheritanceLaw
    }
  ];

  return (
    <main className="publications" dir={isArabic ? 'rtl' : 'ltr'}>
      <section className="page-header">
        <h1>{t.ourPublications}</h1>
        <p>{t.currentLegalInfo}</p>
      </section>

      <section className="articles-section">
        <div className="articles-list">
          {articles.map((article, index) => (
            <article key={index} className="article-card">
              <div className="article-header">
                <h3>{article.title}</h3>
                <div className="article-meta">
                  <span className="date">{article.date}</span>
                  <span className="category">{article.category}</span>
                </div>
              </div>
              <p className="excerpt">{article.excerpt}</p>
              <a href="#read-more" className="read-more">
                {t.readMore} {isArabic ? '←' : '→'}
              </a>
            </article>
          ))}
        </div>
      </section>

      <section className="newsletter-section">
        <h2>{t.subscribe}</h2>
        <p>{t.newPublications}</p>
        <form className="newsletter-form">
          <input type="email" placeholder={t.emailPlaceholder} required />
          <button type="submit">{t.subscribeBtnText}</button>
        </form>
      </section>
    </main>
  );
}

export default Publications;
